/**
 * @description Les statuts des dossiers.
 * - DRAFT
 * - RENEWAL
 * - VALIDATION_PENDING
 * - VALIDATION_PENDING_HR
 * - VALIDATED
 * - REJECTED
 */
export enum Status {
  DRAFT = "DRAFT",
  RENEWAL = "RENEWAL",
  VALIDATION_PENDING = "VALIDATION_PENDING",
  VALIDATION_PENDING_HR = "VALIDATION_PENDING_HR",
  VALIDATED = "VALIDATED",
  REJECTED = "REJECTED",
}

export enum CustomFolderFileType {
  MISSION_CREATION = "mission_file",
  MISSION_RENEWAL = "mission_update",
  MISSION_CREATION_PPH = "mission_file_pph",
  MISSION_RENEWAL_PPH = "mission_update_pph",
}
